export default __webpack_public_path__ + "static/media/aces-loader.a9233ecf.gif";